export type HistoryLayout = "internal" | "overlay";

export const resolveHistoryLayout = (isExpanded: boolean): HistoryLayout =>
  isExpanded ? "internal" : "overlay";
